/** Expected input format: name limitedStops(optional) via(optional) */
export const parseHeadsign = (input) => {
    if (!input || typeof input !== "string") {
        return { name: "", limitedStops: false, via: "" };
    }

    // normalize whitespace
    const normInput = String(input).replaceAll(/\s+/g, " ").trim();

    // split on "via ..." (if present), case-insensitive
    let [name, via] = normInput.split(/\bvia\b/i);
    name = name.trim();
    via = via ? via.trim() : "";

    // detect and strip trailing "Limited stops" (if present), case-insensitive
    let limitedStops = false;
    const lsRegex = /\bLimited\s+stops\b$/i;
    if (lsRegex.test(name)) {
        limitedStops = true;
        name = name.replace(lsRegex, "").trim();
    }

    return { name, limitedStops, via };
};
